import { isNotUndefinedOrNull, type RefOrGetter } from '@/helpers'
import { computed, type ComputedRef, toValue } from 'vue'

export type CssTransitionDto = {
    property: string
    time: number
    easing: CssTransitionEasing
}
export type CssTransitionEasing = 'ease-in' | 'ease-out' | 'ease-in-out'

export function useCssTransition(
    transitions: RefOrGetter<(CssTransitionDto | undefined)[]>
): ComputedRef<string | undefined> {
    return computed(() => getCssTransition(toValue(transitions)))
}

export function getCssTransition(
    transitions: (CssTransitionDto | undefined)[]
): string | undefined {
    const withoutEmpty = transitions.filter(isNotUndefinedOrNull)

    if (!withoutEmpty.length) {
        return undefined
    }

    const mappedTransitions: Record<string, string> = withoutEmpty.reduce(
        (acc: Record<string, string>, curr: CssTransitionDto) => {
            const time = `${(curr.time / 1000).toFixed(3)}s`

            return {
                ...acc,
                [curr.property]: `${time} ${curr.easing}`,
            }
        },
        {} as Record<string, string>
    )

    const transitionProperties = Object.entries(mappedTransitions)
        .map((v) => v.join(' '))
        .join(', ')

    return `transition: ${transitionProperties}`
}
